import React,{useState} from "react";
import ProviderWrap from "../utils/ProviderWrap";
import PricingBlock from "./pricingBlock";

const PricingBlockWrapper = ({link, id, defaultPlane, defaultOwnership, disableFlightCalculator, lang, widgetKey}) => {

  return <ProviderWrap
    link={link}
    lang={lang}
  >
    <PricingBlock
      id={id}
      defaultPlane={defaultPlane}
      defaultOwnership={defaultOwnership}
      disableFlightCalculator={disableFlightCalculator}
      lang={lang}
      widgetKey={widgetKey}
    />
  </ProviderWrap>
}

export default PricingBlockWrapper;
